import { render, staticRenderFns } from "./role-list.vue?vue&type=template&id=49336d3f"
import script from "./role-list.vue?vue&type=script&lang=js"
export * from "./role-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports